(() => {
  const STORAGE_KEY = "shopify_wishlist";
  const API_BASE = () =>
    String(window.WISHLIST_API_URL || "https://personalize.salty.co.in").replace(
      /\/$/,
      "",
    );

  const customerId = () => {
    const id = window.SHOPIFY_CUSTOMER_ID;
    if (id == null || id === "" || id === "null") return null;
    return String(id);
  };

  const isLoggedIn = () => !!customerId();

  const requireLogin = () => {
    if (isLoggedIn()) return true;

    window.location.href = "/account/login";
    return false;
  };
  const uniqueHandles = (handles) => {
    const seen = new Set();
    const result = [];
    for (const value of handles || []) {
      const handle = String(value || "").trim();
      if (!handle || seen.has(handle)) continue;
      seen.add(handle);
      result.push(handle);
    }
    return result;
  };

  const readLocal = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return uniqueHandles(Array.isArray(parsed) ? parsed : []);
    } catch {
      return [];
    }
  };

  const writeLocal = (handles) => {
    const next = uniqueHandles(handles);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  };

  const parseApiHandles = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return uniqueHandles(payload);
    if (Array.isArray(payload.handles)) return uniqueHandles(payload.handles);
    if (typeof payload === "string") return uniqueHandles(payload.split(","));
    if (typeof payload.handles === "string") {
      return uniqueHandles(payload.handles.split(","));
    }
    return [];
  };

  const setCount = (count) => {
    document.querySelectorAll(".wishlist-count").forEach((el) => {
      el.textContent = String(count);
      el.setAttribute("data-count", String(count));
    });
  };

  const updateIcons = (handles = readLocal()) => {
    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const handle = (btn.dataset.handle || "").trim();
      if (!handle) return;
      const active = handles.includes(handle);
      btn.classList.toggle("active", active);
      btn.classList.remove("hidden");
      btn.style.display = '';
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute(
        "aria-label",
        active ? "Remove from wishlist" : "Add to wishlist",
      );
    });
    setCount(handles.length);
  };

  const saveRemote = async (handles) => {
    const id = customerId();
    if (!id) return;

    try {
      await fetch(`${API_BASE()}/api/wishlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          actionType: handles.length === 0 ? "remove" : "save",
          productHandle: handles.join(","),
          customerId: id,
        }),
      });
    } catch (error) {
      console.error("Wishlist save failed:", error);
    }
  };

  const fetchRemote = async () => {
    const id = customerId();
    if (!id) return [];

    try {
      const response = await fetch(
        `${API_BASE()}/api/wishlist-list?customerId=${encodeURIComponent(id)}`,
      );
      if (!response.ok) return [];
      return parseApiHandles(await response.json());
    } catch (error) {
      console.error("Wishlist list failed:", error);
      return [];
    }
  };

  const mergeWishlists = (localHandles, remoteHandles) =>
    uniqueHandles([...(remoteHandles || []), ...(localHandles || [])]);

  const persist = async (handles) => {
    const next = writeLocal(handles);
    updateIcons(next);
    await saveRemote(next);
    return next;
  };

  const showEmpty = (container) => {
    const text = container?.dataset.emptyText || "Nothing on your wishlist? We’ll pretend we’re not offended.";
    if (!container) return;
    container.innerHTML = `<div class="wishlist-empty-text">${text}</div>`;
    // document.getElementById("MainContent")?.classList.add("wishlist-empty");
  };

  const loadWishlistPage = async (handles) => {
    const container = document.getElementById("wishlist-container");
    if (!container) return;

    const list = uniqueHandles(handles);
    container.innerHTML = "";

    if (!list.length) {
      showEmpty(container);
      container.classList.remove("is-loading");
      return;
    }

    container.classList.add("is-loading");
    document.getElementById("MainContent")?.classList.remove("wishlist-empty");

    const cards = await Promise.all(
      list.map(async (handle) => {
        try {
          const response = await fetch(
            `/products/${encodeURIComponent(handle)}?view=wishlist-card`,
          );
          if (!response.ok) return null;
          const html = await response.text();
          const temp = document.createElement("div");
          temp.innerHTML = html;
          return temp.querySelector(".wishlist-item");
        } catch {
          return null;
        }
      }),
    );

    container.classList.remove("is-loading");

    const fragment = document.createDocumentFragment();
    cards.forEach((item) => {
      if (item) fragment.appendChild(item);
    });

    if (!fragment.childNodes.length) {
      showEmpty(container);
      return;
    }

    container.appendChild(fragment);
    updateIcons(list);
    refreshJudgeMeRatings();
    initAjaxProductForms();
  };

  const toggleHandle = async (handle) => {
    if (!handle) return;
    const current = readLocal();
    const next = current.includes(handle)
      ? current.filter((item) => item !== handle)
      : [...current, handle];
    await persist(next);
  };

  const removeHandle = async (handle, removeBtn) => {
    if (!handle) return;
    const next = await persist(readLocal().filter((item) => item !== handle));
    const item =
      removeBtn.closest(".wishlist-item") ||
      removeBtn.closest(".card-wrapper")?.parentElement;
    item?.remove();

    const container = document.getElementById("wishlist-container");
    if (container && !container.querySelector(".wishlist-item") && !next.length) {
      showEmpty(container);
    }
  };

  document.body.addEventListener("click", (event) => {
    const removeBtn = event.target.closest(".wishlist-remove");
    if (removeBtn) {
      event.preventDefault();
      removeHandle((removeBtn.dataset.handle || "").trim(), removeBtn);
      return;
    }

    const btn = event.target.closest(".wishlist-btn");
    if (!btn) return;
    event.preventDefault();
    if (!requireLogin()) return;
    toggleHandle((btn.dataset.handle || "").trim());
  });

  const init = async () => {

     if (!isLoggedIn()) {
      updateIcons([]);
      if(document.getElementById("wishlist-container")){
        window.location.href = "/account/login";
      }
      return;
    }
    const localHandles = readLocal();
    updateIcons(localHandles);

    const remoteHandles = await fetchRemote();
    const merged = customerId()
      ? mergeWishlists(localHandles, remoteHandles)
      : localHandles;

    if (customerId() && merged.join(",") !== remoteHandles.join(",")) {
      await persist(merged);
    } else {
      writeLocal(merged);
      updateIcons(merged);
    }

    await loadWishlistPage(merged);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("wishlist:refresh", (event) => {
    const container = event.detail?.container || document;
    const handles = event.detail?.handles || readLocal();
    updateIcons(handles, container);
  });
})();

function refreshJudgeMeRatings() {
  document.querySelectorAll('#wishlist-container .jdgm-prev-badge').forEach(function (badge) {
    const stars = badge.querySelector('.jdgm-prev-badge__stars');
    const text = badge.querySelector('.jdgm-prev-badge__text');
    if (!stars || !text) return;
    const score = stars.getAttribute('data-score');
    if (score) {
      text.textContent = score;
    }
  });
}

function initAjaxProductForms() {
  document.querySelectorAll('#wishlist-container .product-single__form').forEach((form) => {
    if (form.dataset.ajaxProductInitialized === 'true') return;
    new theme.AjaxProduct(form);
    form.dataset.ajaxProductInitialized = 'true';
  });
}

// function waitForElement(selector, callback, wrapper = document) {
//   const interval = setInterval(() => {
//     const element = wrapper.querySelector(selector);
//     if (element) {
//       clearInterval(interval);
//       callback(element);
//     }
//   }, 100);
// }

function waitForElement(
  selector,
  callback,
  wrapper = document,
  waitAfterFound = 0
) {
  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    const element = wrapper.querySelector(selector);
    if (element) {
      clearInterval(interval);
      setTimeout(() => {
        callback(element);
      }, waitAfterFound);
      return;
    }
    if (attempts >= 3) {
      clearInterval(interval);
    }
  }, waitAfterFound || 100);
}

document
  .querySelectorAll('.helium-grid-container, .helium-custom-recommendations')
  .forEach((wrapper) => {
    waitForElement('[data-helium-name="product-item"]', () => {
      document.dispatchEvent(new CustomEvent('wishlist:refresh'));
    }, wrapper, 1000);
  });